import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { ContentService } from '../../services/content.service';

@Component({
  selector: 'app-related-product',
  standalone: true,
  imports: [CommonModule, CarouselModule, ButtonModule, TagModule],
  templateUrl: './related-product.component.html',
  styleUrl: './related-product.component.scss'
})
export class RelatedProductComponent {
  @Input() products: any = [];
  @Input() isVertical: boolean = false;
  @Input() numSlides: number = 4;
  @Input() title: string = '';
  
    responsiveOptions: any[] | undefined;

    constructor(
      private contentService: ContentService
    ) {

    }

  
    ngOnInit() {
      this.getProduct();
  
       this.responsiveOptions = [
            {
                breakpoint: '1199px',
                numVisible: 1,
                numScroll: 1
            },
            {
                breakpoint: '991px',
                numVisible: 2,
                numScroll: 1
            },
            {
                breakpoint: '767px',
                numVisible: 1,
                numScroll: 1
            }
        ];
    }

    getProduct(catalog?: any) {
      this.contentService.getProductByMainCategories(catalog?.categoria ?? '').subscribe((res: any) => {
        this.products = res;
      });
    }

    getSeverity(status: string) {
        switch (status) {
            case 'INSTOCK':
                return 'success';
            case 'LOWSTOCK':
                return 'warning';
            case 'OUTOFSTOCK':
                return 'danger';
            default:
              return 'success';
        }
    }

}
